import { useSubscription } from "@/hooks/use-subscription";
import PlanSelectionModal from "./PlanSelectionModal";

export default function RequireSubscription() {
  const { isSubscribed, isTrialActive, loading } = useSubscription();

  if (loading) return null;
  // Abonné ou essai Pro encore actif → accès libre.
  if (isSubscribed || isTrialActive) return null;

  // Essai Pro terminé sans abonnement → choix de plan obligatoire.
  return <PlanSelectionModal open onClose={() => {}} closable={false} trialExpired />;
}
